import io from 'socket.io-client';
import Vue from 'vue';


let socket = null;

const createSocket = (token, store) => {
  // validates if the message should be handle within this tab. Should be used for user specific messages
  function validate(handler) {
    return async (message) => {
      const isValidJobId = await store.dispatch('socket/isValidJobId', message.jobId);
      if (message && isValidJobId) {
        handler(message);
      }
    };
  }

  try {
    if (socket) socket.close();

    if (!token) return;

    socket = io(import.meta.env.VUE_APP_API_URL, {
      query: {
        authorization: `JWT ${token}`,
      },
      reconnection: true,
    });

    socket.on('connect', () => {
      store.dispatch('socket/onConnected', socket);
      store.dispatch('session/init', socket);
    });

    socket.on('disconnect', () => {
      store.dispatch('socket/onDisconnected');
    });

    // socket events
    socket.on('vehicle_remove_result', validate((message) => {
      store.dispatch('ads/handleRemoveResult', message);
    }));
    socket.on('vehicle_push_result', validate((message) => {
      store.dispatch('ads/handlePushResult', message);
    }));
    socket.on('vehicle_update_result', validate((message) => {
      store.dispatch('ads/handleUpdateResult', message);
    }));
    socket.on('vehicle_img_result', validate((message) => {
      store.dispatch('ads/handleImgResult', message);
    }));
    socket.on('vehicle_publication_result', validate((message) => {
      store.dispatch('ads/handlePublicationResult', message);
    }));
    socket.on('vehicle_auto_ad_updates', validate((message) => {
      store.dispatch('ads/handleAutoAdUpdates', message);
    }));
    socket.on('branch_import', validate((message) => {
      store.dispatch('inserateImporter/handleImportResult', message);
    }));
    socket.on('branch_merge_import', validate((message) => {
      store.dispatch('inserateImporter/handleImportMergeResult', message);
    }));
    socket.on('branch_assign_inserate', ((message) => {
      store.dispatch('inserateImporter/handleAssignResult', message);
    }));
    socket.on('new_mail', (message) => {
      store.dispatch('internalEmail/handleNewMail', message);
    });
    socket.on('marketplace_outbidden', (message) => {
      store.dispatch('marketplaceDetail/handleOutbidden', message);
    });
    socket.on('email_account_invalid', (message) => {
      store.commit('auth/SET_NYLAS_GRANT_STATUS', message.status);
    });
    socket.on('alzura_sso_forced_logout', (message) => {
      if (!store.getters['auth/loggedIn']) return;
      store.commit('auth/SET_FORCED_LOGOUT_REASON', message.reason);
    });

    // Send errors to backend via socket
    const handleError = (...args) => {
      args = args.map((arg) => {
        if (arg instanceof Error) {
          if (
            arg.name === 'ChunkLoadError'
            || arg.message.startsWith('Failed to fetch dynamically imported module')
          ) {
            setTimeout(() => {
              window.location.reload();
            }, 0);

            return null;
          }

          return {
            message: arg.message,
            stack: arg.stack,
            ...arg,
          };
        }
        return arg;
      });

      args = args.filter(Boolean);
      if (!args.length) return;

      if (socket && socket.connected) {
        const _err = new Error('CreateStack');
        socket.send('FRONTEND_ERROR', {
          location: window.location.href,
          stack:  _err.stack.split('\n').slice(3).join('\n') || undefined,
        }, args);
      }
    };

    const consoleError = console.error;
    console.error = (...args) => {
      handleError(...args);
      consoleError(...args);
    };

    window.addEventListener('error', (event) => {
      handleError(event.error);
    });

    Vue.prototype.$socket = socket;
  } catch (error) {
    console.error(error);
    socket = null;
  }
};


export default async (store) => {
  const accessToken = localStorage.getItem('auth.accessToken');
  createSocket(JSON.parse(accessToken), store);

  store.subscribe(({ type, payload }) => {
    if (type !== 'auth/SET_ACCESS_TOKEN') return;
    createSocket(payload, store);
  });
};
